import ENDPOINTS from '@/constants/apiEndpoints';
import { fetcher } from '@/utils/request';
import useSWR from 'swr';
import useUserInfo from './useUserInfo';

export const useCedefiClaimableRewards = () => {
  const { userInfo } = useUserInfo();

  const { data, mutate, isLoading, error } = useSWR(
    userInfo?.user_address
      ? [ENDPOINTS.getAllClaimableScores, userInfo?.user_address]
      : null,
    ([url]: [string, string]) => fetcher(url)
  );

  return {
    data: data?.data || data,
    mutate,
    isLoading,
    error
  };
};
